<script setup>
import xModal from '~/components/common/xModal.vue'
import { useFutureStore } from '~/store/future'
import { usePanelStore } from '~/store/panel'
import { useStorage } from '@vueuse/core'

const { t } = useI18n()
const future = useFutureStore()
const panel = usePanelStore()

const noTips = ref(false)
const orderConfirm = useStorage('futureOrderConfirm', 0)

const info = computed(() => {
  const directions = {
    '1': {
      1: t('开多'),
      2: t('平空'),
    },
    '-1': {
      1: t('开空'),
      2: t('平多'),
    },
  }
  const { contractId, side = 1, positionEffect: pe = 1 } = future.modalData.orderConfirm
  const { code, displayName } = future.getInfo(contractId)
  const { leverage, isolated } = future.getPositionConfigByCode(code)
  const marginText = isolated ? t('逐仓') : t('全仓')
  const directionText = directions[side][pe]

  return {
    displayName,
    marginText,
    directionText,
    leverageText: `${leverage}X`,
  }
})

const ul = computed(() => {
  const { price, contractId, quantity, orderConditions, side } = future.modalData.orderConfirm
  const { code, ps, quote, size, as, base } = future.getInfo(contractId)
  const { leverage } = future.getPositionConfigByCode(code)
  const overview = future.getOverviewByCode(code)

  const list = [
    { label: t('开仓价格'), key: 'price', value: price ? `${fix(price, ps)} ${quote}` : t('市价') },
    { label: t('当前价格'), key: 'lastPrice', value: `${fix(overview.c ?? '--', ps)} ${quote}` },
    { label: t('数量'), key: 'amount', value: `<p class="text-end">${fix(mul(quantity, size), as)} ${base}</p><p class="text-xs text-end text-textSecondary">≈ ${fix(future.getRealAmount(quantity, { code, forceQuote: true }), ps)} ${quote}</p>` },
    { label: t('保证金'), key: 'margin', value: `${fix(mul(future.getOneLotCost({ price: panel.getPriceBySide({ price, side }), code, leverage }), quantity), 2)} ${quote}` },
    // { label: t('强平价格'), key: 'liquidPrice', value: 1 },
  ]

  const tp = orderConditions?.find(i => i.stopCondition === 1)
  const sl = orderConditions?.find(i => i.stopCondition === 2)
  tp && list.push({ label: t('止盈触发价'), key: 'tpPrice', value: fix(tp.stopPrice, ps), class: 'text-buy' })
  sl && list.push({ label: t('止损触发价'), key: 'slPrice', value: fix(sl.stopPrice, ps), class: 'text-sell' })

  return list
})

function ok() {
  orderConfirm.value = +!noTips.value
  future.modalData.orderConfirm = {}
  return true
}
</script>

<template>
  <xModal :title="$t('下单确认')" :ok="ok" @closed="noTips = false">
    <div class="font-medium">
      <span>{{ `${info.displayName}·${info.marginText}` }}</span>·<span :class="{ 'text-buy': future.modalData.orderConfirm.side === 1, 'text-sell': future.modalData.orderConfirm.side === -1 }">{{ `${info.directionText}·${info.leverageText}` }}</span>
    </div>
    <ul class="pb-3 mt-3 space-y-3 text-sm border-b border-border">
      <li v-for="i in ul" :key="i.key" class="flex justify-between">
        <div class="text-textTertiary">
          {{ i.label }}
        </div>
        <div class="text-textPrimary" :class="i.class" v-html="i.value" />
      </li>
    </ul>
    <CommonXCheckbox v-model="noTips" class="mt-4">
      <div>{{ $t('不再提示,可在"偏好设置"中再次打开') }}</div>
    </CommonXCheckbox>
  </xModal>
</template>
